import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Input } from "antd";
import classNames from "classnames";

interface SearchProps {
    onChange: (text: string) => void;
    className?: string;
}

export default function Search({ onChange, className }: SearchProps) {
    const [text, setText] = useState("");

    function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        onChange(text.trim());
    }

    return (
        <form className={classNames(style.root, className)} onSubmit={onSubmit}>
            <Input
                className={style.input}
                placeholder="请输入姓名、学号查看学生投票情况"
                onChange={e => setText(e.target.value)}
            />
            <Button
                htmlType="submit"
                type="primary"
                className={style.searchBtn}>
                查询
            </Button>
        </form>
    );
}
